import { Button } from 'react-bootstrap'
import { ListFilter } from 'lucide-react'

export default function Search(props) {

    const { onClick, tooltip_content } = props

    return (
        <>
            <Button
                variant="light"
                size='sm'
                onClick={onClick}
                className='d-flex align-items-center justify-content-center gap-2 border search_btn'
            >
                <ListFilter size={20} />
                {tooltip_content}
            </Button>
        </>
    )
}